import { useState } from "react";
import { addFichiersTicket } from "../lib/ticket";

/**
 * Fournit une fonction `uploadFichiers(ticketId, fichiers)` pour envoyer des fichiers sur un ticket et expose `{ uploadFichiers, loading, erreur }`.
 *
 * @returns {{ uploadFichiers: Function, loading: boolean, erreur: NrlkException|null }}
 */
export const useUploadFichiers = () => {
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState(null);

  const uploadFichiers = async (ticketId, fichiers) => {
    setLoading(true);
    setErreur(null);
    try {
      const result = await addFichiersTicket(ticketId, fichiers);
      return result; // liste des ID de fichiers
    } catch (err) {
      setErreur(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    uploadFichiers,
    loading,
    erreur,
  };
};
